<template>
  <div class="text-center">
    <b-tabs
      pills
      content-class="mt-3"
      fill
    >
      <b-tab
        title="How does Blue Crates Work"
        active
      >
        <div class="video-container">
          <iframe
            class="video"
            src="https://www.youtube.com/embed/xjVIpdVFs5g"
            frameborder="0"
            allowfullscreen
          />
        </div>
      </b-tab>

      <b-tab title="Don'ts of Storage">
        <div class="video-container">
          <iframe
            class="video"
            src="https://www.youtube.com/embed/KsH-9z3NKmY"
            frameborder="0"
            allowfullscreen
          />
        </div>
      </b-tab>

      <b-tab title="Packing for Storage">
        <div class="video-container">
          <iframe
            class="video"
            src="https://www.youtube.com/embed/HEbZRNT8MyQ"
            frameborder="0"
            allowfullscreen
          />
        </div>
      </b-tab>

      <b-tab title="Storage Bags">
        <div class="video-container">
          <iframe
            class="video"
            src="https://www.youtube.com/embed/7NJtj8htW-g"
            frameborder="0"
            allowfullscreen
          />
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class VideoSectionTabs extends Vue {
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.video-container {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
}

.video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

::v-deep {
  .nav-pills .nav-link.active {
    font-weight: bold;
    color: #008fc4;
  }

  .nav-pills > .nav-item {
    padding-left: 0.5rem;
    padding-right: 0.5rem;

    //&:not(:last-child) {
    //  margin-right: 0.25rem;
    //}
  }

  .nav-pills .nav-link,
  .nav-pills > .nav-link {
    background-color: #fff;
    color: #333;
    margin-bottom: 0.5rem;
    text-decoration: none;
  }
}
</style>
